import { render, staticRenderFns } from "./template.html?vue&type=template&id=36cde7c8&scoped=true&"
import script from "./ImagePairsTrial.vue?vue&type=script&lang=js&"
export * from "./ImagePairsTrial.vue?vue&type=script&lang=js&"
import style0 from "./ImagePairsTrial.vue?vue&type=style&index=0&id=36cde7c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cde7c8",
  null
  
)

export default component.exports